import React from 'react';
import PropTypes from 'prop-types';

const MilestoneBar = (props) => {
  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: '5px',
        boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.2)',
      }}
      className="slds-p-vertical_x-small"
    >
      <ul className="milestone-progress-bar slds-grid" style={{ paddingLeft: '15%', paddingRight: '15%'}}>
        {props.triggerContent !== '' ? (
          <li className="slds-size_1-of-5">
            <span
              className={props.milestone !== 'trigger' ? 'completed' : null}
              onClick={props.onMilestoneClicked}
              data-milestone="trigger"
              data-clickable={true}
              title={props.triggerContent}
            >
              Trigger
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-5">
            <div
              className={
                props.milestone === 'trigger'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneClicked}
              data-milestone="trigger"
              data-clickable={false}
              title="The Trigger milestone represents the single event that causes your Hero to set off on this journey."
            >
              Trigger
            </div>
          </li>
        )}
        {props.triumphContent !== '' ? (
          <li className="slds-size_1-of-5">
            <span
              className={props.milestone !== 'triumph' ? 'completed' : null}
              onClick={props.onMilestoneClicked}
              data-milestone="triumph"
              data-clickable={true}
              title={props.triumphContent}
            >
              Triumph
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-5">
            <div
              className={
                props.milestone === 'triumph'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneClicked}
              data-milestone="triumph"
              data-clickable={false}
              title="The Triumph milestone represents the end of your Hero's journey. This event should encapsulate all of the success and transformation of your hero on their journey."
            >
              Triumph
            </div>
          </li>
        )}
        {props.guideContent !== '' ? (
          <li className="slds-size_1-of-5">
            <span
              className={props.milestone !== 'guide' ? 'completed' : null}
              onClick={props.onMilestoneClicked}
              data-milestone="guide"
              data-clickable={true}
              title={props.guideContent}
            >
              Guide
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-5">
            <div
              className={
                props.milestone === 'guide'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneClicked}
              data-milestone="guide"
              data-clickable={false}
              title="The Guide milestone represents the event that guides our hero to your customer's solution. The Guide milestone often becomes the marketing arc of our story with targeted ads and curated marketing journeys, but don't let marketing silo your conversation."
            >
              Guide
            </div>
          </li>
        )}
        {props.keyContent !== '' ? (
          <li className="slds-size_1-of-5">
            <span
              className={props.milestone !== 'key' ? 'completed' : null}
              onClick={props.onMilestoneClicked}
              data-milestone="keyVar"
              data-clickable={true}
              title={props.keyContent}
            >
              Key
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-5">
            <div
              className={
                props.milestone === 'key'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneClicked}
              data-milestone="keyVar"
              data-clickable={false}
              title="The Key milestone represents the point when your Hero adopts your customer's solution. If this were a standard sales story, you can think of this milestone as the point of sale."
            >
              Key
            </div>
          </li>
        )}
        {props.crisisContent !== '' ? (
          <li className="slds-size_1-of-5">
            <span
              className={props.milestone !== 'crisis' ? 'completed' : null}
              onClick={props.onMilestoneClicked}
              data-milestone="crisis"
              data-clickable={true}
              title={props.crisisContent}
            >
              Crisis
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-5">
            <div
              className={
                props.milestone === 'crisis'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneClicked}
              data-milestone="crisis"
              data-clickable={false}
              title="We wouldn't have a very compelling story if your customer doesn't have a chance to save the day, right? The Crisis milestone represents hardship that your Hero experiences during their journey. This shouldn't be at the fault of either your Hero or your customer, but it should showcase how in your customer's future state, they make simple work of this problem. "
            >
              Crisis
            </div>
          </li>
        )}
      </ul>
    </div>
  );
};

MilestoneBar.propTypes = {
  onMilestoneClicked: PropTypes.func.isRequired,
  triggerContent: PropTypes.string.isRequired,
  guideContent: PropTypes.string.isRequired,
  keyContent: PropTypes.string.isRequired,
  crisisContent: PropTypes.string.isRequired,
  triumphContent: PropTypes.string.isRequired,
};

export default MilestoneBar;
